import type { RawArticleTile, Article } from './types'
import { imageParser } from '../components/props/parsers/Image'

export function articleParser(rawTile: RawArticleTile): Article {
  const { acf } = rawTile
  const { card } = acf
  const { category, image, ...rest } = card

  return {
    categories: category,
    ...rest,
    ...imageParser(image),
  }
}
